import { render, staticRenderFns } from "./EditUserCompanyPage.vue?vue&type=template&id=2cdf5ef3&"
import script from "./EditUserCompanyPage.vue?vue&type=script&lang=js&"
export * from "./EditUserCompanyPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports